import { Trans } from '@lingui/macro';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FormSection from '../../../form/FormSection';
import VirtualMachineProperties from './VirtualMachineProperties';
import HypervisorProperties from './HypervisorProperties';
import VcenterProperties from './VcenterProperties';
import { useVirtualInfraContext } from '../InfrastructureUtils';

const useStyles = makeStyles((theme) => ({
    propertiesContainer: {
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
        padding: theme.spacing(2),
    },
}));

/**
 * Displays properties section for virtual infrastructure entities
 * Shows appropriate property component based on entity type
 */
const VirtualPropertiesSection = () => {
    const classes = useStyles();
    const context = useVirtualInfraContext();

    if (context.isCreateAction) {
        return null;
    }

    return (
        <FormSection title={<Trans>Properties</Trans>}>
            <Box mt={1.5} mb={0.5} className={classes.propertiesContainer}>
                {context.isVirtualMachine && <VirtualMachineProperties />}
                {context.isHypervisor && <HypervisorProperties />}
                {context.isVCenter && <VcenterProperties />}
            </Box>
        </FormSection>
    );
};

export default VirtualPropertiesSection;
